module.exports = __webpack_public_path__ + "static/media/grass_fed_beef.6a353e77.mp4";